<script setup lang="ts">
import RangeSliderInput from '@components/RangeSliderInput.vue';
import Typography from '@components/Typography.vue';
import { trans } from '@tools/translation.ts';
import { range } from 'lodash-es';
import { ref } from 'vue';

// @todo : move to store, @see https://bureaux-a-partager.atlassian.net/browse/MATCH-10559
const budgetMin = ref<number | null>(null);
const budgetMax = ref<number | null>(null);
</script>

<template>
  <div class="flex flex-col gap-4 p-3 lg:p-4">
    <RangeSliderInput
      v-model:min-value="budgetMin"
      v-model:max-value="budgetMax"
      :values="[
        ...range(0, 10_000, 500),
        ...range(10_000, 100_000 + 5_000, 5_000),
      ]"
      :major-ticks="[ 0, 5_000, 10_000, 100_000 ]"
      :min-label="trans('search.filters.budget.min')"
      :max-label="trans('search.filters.budget.max')"
      :unit="trans('search.filters.budget.placeholder')"
    />

    <Typography
      variant="body"
      class="px-6 text-center"
    >
      {{ trans('search.filters.budget.note') }}
    </Typography>
  </div>
</template>
